#import "./fragments/teamFragment.graphql"

query getValueGraph($input: ValueGraphInput!) {
  valueGraph(input: $input) {
    objectives {
      id
      name
      objectiveType
      objectiveTypeDisplayName
      dataSource {
        type
      }
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      parentIds
      childObjectiveIds
      teams {
        ...TeamFragment
      }
    }
  }
}
